import { DeliveryItem } from "../domain/entities/delivery";
import { DeliverItemsCreationStrategy } from "../domain/strategies/creation/delivery-items.strategy";

import { maxWeightPerTrack } from "@/app/constants";

export class DeliveryService {
    static createDeliveryItems(type: string): DeliveryItem {
        const strategy = new DeliverItemsCreationStrategy(type);

        return strategy.create() as unknown as DeliveryItem;
    }

    static calculateTracksNumber = (
        weight: number,
    ) => {
        const numberOfTracks = Math.ceil(weight / maxWeightPerTrack)
        return Math.ceil(numberOfTracks);

    };
}
